import { useQuery } from '@tanstack/react-query';
import { http } from '@lib/api';
import { queryKeys } from '@lib/queryKeys';
import type { components } from '@/types/api.generated';

export type EnRouteSummaryWire = components['schemas']['DispatchEnRoute'];

/**
 * The drivers on the road and the job totals of one shipping day (#2482 read
 * endpoint, D1 only). Today is re-read every minute so the pane keeps up with
 * the delivery webhooks; another day does not change, so it is not polled.
 * The focus cards (#2485) pass `enabled` so they read it only when today's
 * counts call for it.
 */
export function useEnRouteSummary(date: string, isToday: boolean, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.dispatch.enRoute(date),
    queryFn: () => http.get<EnRouteSummaryWire>('/api/dispatch/en-route', { params: { date } }),
    staleTime: 30_000,
    refetchInterval: isToday ? 60_000 : false,
    refetchIntervalInBackground: false,
    enabled: options?.enabled ?? true,
  });
}
